import { buildLegalReferralRows } from "@/lib/legalReferral";

export { buildLegalReferralRows };

export function ReportLegalReferralMatrix({ answers }) {
  const rows = buildLegalReferralRows(answers);
  return (
    <div className="space-y-4">
      <p className="text-sm leading-relaxed text-muted-foreground">
        This section identifies readiness indicators, evidence gaps, operational compliance exposure and referral triggers based on information supplied by the provider. It does not determine legal compliance or predict any regulator, auditor or legal outcome.
      </p>
      <div className="overflow-x-auto rounded-sm border border-border">
        <table className="w-full min-w-[900px] text-left text-sm" data-testid="report-legal-referral-matrix">
          <thead className="bg-muted/60 text-xs uppercase tracking-[0.16em] text-muted-foreground">
            <tr>
              <th className="px-4 py-3">Area checked</th>
              <th className="px-4 py-3">Evidence requested</th>
              <th className="px-4 py-3">Evidence status</th>
              <th className="px-4 py-3">Red flag</th>
              <th className="px-4 py-3">Referral trigger</th>
              <th className="px-4 py-3">Suggested next action</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.area} className="border-t border-border align-top">
                <td className="px-4 py-3 font-medium text-foreground">{row.area}</td>
                <td className="px-4 py-3 text-muted-foreground">{row.evidenceRequested}</td>
                <td className="px-4 py-3 text-muted-foreground">{row.evidenceStatus}</td>
                <td className="px-4 py-3 text-muted-foreground">{row.redFlag}</td>
                <td className="px-4 py-3 text-muted-foreground">{row.referralTrigger}</td>
                <td className="px-4 py-3 text-muted-foreground">{row.suggestedNextAction}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
